<form [formGroup]="costForm">
	<div class="flex-table" role="rowgroup" *ngFor="let type of createdCapabilites" [formGroupName]="type.paymentType">
		<div class="flex-row rowspan">
			<input-wrapper>
				<input class="fix-width-input" formControlName="paymentType" type="text" />
			</input-wrapper>
		</div>
		<div class="column">
			<ng-container
				formArrayName="costs"
				*ngFor="let accountRoute of getCostFormGroupArray(type.paymentType).controls; let i = index"
			>
				<div class="flex-row" [formGroupName]="i">
					<div class="flex-cell" role="cell">
						<input-wrapper>
							<input id="billingType" class="fix-width-input" formControlName="billingType" type="text" />
						</input-wrapper>
					</div>
					<div class="flex-cell" role="cell">
						<input-wrapper>
							<input
								id="payoutAccount"
								class="fix-width-input"
								formControlName="payoutAccount"
								type="text"
							/>
						</input-wrapper>
					</div>
					<div class="flex-cell" role="cell">
						<input-wrapper>
							<input id="route" class="fix-width-input" formControlName="route" type="text" />
						</input-wrapper>
					</div>
					<div class="flex-cell" role="cell">
						<input-wrapper>
							<input-autocomplete
								id="currency"
								formControlName="currency"
								label="Select funding currency"
								[options]="currencyOptions$ | async"
								width="120px"
								[defaultValue]="accountRoute.get('currency')?.value"
							>
							</input-autocomplete>
						</input-wrapper>
					</div>
					<div class="flex-cell" role="cell">
						<input-wrapper>
							<input id="paymentFee" class="fix-width-input" formControlName="paymentFee" type="number" />
							<div id="paymentFee" input-errors>
								<ng-container
									*ngIf="
										(accountRoute.get('paymentFee')?.touched ||
											accountRoute.get('paymentFee')?.dirty) &&
										accountRoute.get('paymentFee')?.errors?.required
									"
								>
									<div>Set a payment fee</div>
								</ng-container>
								<ng-container
									*ngIf="
										(accountRoute.get('paymentFee')?.touched ||
											accountRoute.get('paymentFee')?.dirty) &&
										accountRoute.get('paymentFee')?.errors?.min
									"
								>
									<div>The minimum value is 0</div>
								</ng-container>
								<ng-container *ngIf="accountRoute.hasError('atLeastOne')">
									<div>At least one fee must more than 0</div>
								</ng-container>
							</div>
						</input-wrapper>
					</div>
					<div class="flex-cell" role="cell">
						<input-wrapper>
							<input id="monthlyFee" class="fix-width-input" formControlName="monthlyFee" type="number" />
							<div id="monthlyFee" input-errors>
								<ng-container
									*ngIf="
										(accountRoute.get('monthlyFee')?.touched ||
											accountRoute.get('monthlyFee')?.dirty) &&
										accountRoute.get('monthlyFee')?.errors?.required
									"
								>
									<div>set a payment fee</div>
								</ng-container>
								<ng-container
									*ngIf="
										(accountRoute.get('monthlyFee')?.touched ||
											accountRoute.get('monthlyFee')?.dirty) &&
										accountRoute.get('monthlyFee')?.errors?.min
									"
								>
									<div>The minimum value is 0</div>
								</ng-container>
								<ng-container *ngIf="accountRoute.hasError('atLeastOne')">
									<div>At least one fee must more than 0</div>
								</ng-container>
							</div>
						</input-wrapper>
					</div>
					<div class="notes-cell" role="cell">
						<input-wrapper id="openNotes">
							<input class="notes-input" formControlName="notes" type="text" />
							<app-icon
								(click)="openDialog(type.paymentType, accountRoute.get('notes')?.value, i)"
								matSuffix
								[name]="'edit-2'"
							></app-icon>
						</input-wrapper>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</form>
